import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  padding: 40px 40px 0px 40px;
`;

export const Title = styled.div`
  padding: 0px 0px 26px 0px;
  font-family: Roboto;
  font-size: 25px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`

export const SwipeableContainer = styled.div`
  padding: 40px 0px 0px 0px;
`

export const ViewAllButton = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 40px;
  top: 95px;
  right: 40px;
  border-radius: 5px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
  cursor: pointer;
  &:hover {
    background-color: ${C.LIGHTEST_GRAY};
  }
`

export const LoaderContainer = styled.div`
  height: 347px;
  display: flex;
  justify-content: center;
  flex-direction: column;
`